import { Component, Input, OnInit } from '@angular/core';
import { curveCardinal } from 'd3-shape';
import { Ilinechartdata } from '@app/interfaces/ILineChartdata';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit {
  @Input() data: any; //data coming from parent component
  @Input() colorScheme: any //colorscheme passed through parent component
  @Input() graphData: any;// graphdata passed through parent component
  @Input() totalCount: any;
  @Input() style: Ilinechartdata //styles coming from parent component
  /**
   * all the styling and data input are mentioned here.
   */

  results: any;
  curve = curveCardinal.tension(0.1);
  ngOnInit(): void {
  }
}
